import _ from "lodash";
import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import LoadingOverlay from "react-loading-overlay";
import { Col, Row } from "react-bootstrap";
import BasicLayout from "../../../layouts/basiclayout";
import {
  getDeletableDisplayCategories,
  getMediaIdsToDelete,
  convertArrayToObjMap,
} from "../helper";
import { MPSelect } from "../../../widgets/common";
import { confirmAlert } from "react-confirm-alert";
import AppModal from "../../../widgets/modal";
import { ScaleLoader } from "react-spinners";
import QalboxTable from "../../../widgets/qalbox-table";
import { BrandModal } from "./brandModal";
import { getBrandDisplayData } from "./helpers/brandDataTransform";
import { getQalboxBrandColumns } from "./helpers/brandColumns";
import { useFetchBrands } from "./hooks/useFetchBrand";
import { useDeleteBrand } from "./hooks/useDeleteBrand";

const QalboxBrands = () => {
  const [refresh, setRefresh] = useState(false);
  const [ShowBrandModal, setShowBrandModal] = useState(false);
  const [brandRow, setBrandRow] = useState(null);
  const [active, setActive] = useState(true);
  const [brandsResponse, isLoadingBrands, errorFetching] = useFetchBrands(active, refresh);
  const [deleteBrand, isDeleting, isDeletingError] = useDeleteBrand();

  const onDeleteSelected = (selectedFlatRows, resetSelectedRows) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <AppModal
            show={true}
            showBody={true}
            headingText={`Are you sure want to delete the following ${_.size(
              selectedFlatRows
            )} display categories items ?`}
            modalBody={getDeletableDisplayCategories(selectedFlatRows)}
            modalBodyClassName={"precalcs-diff-merge-view"}
            closeButtonText={"No"}
            okButtonText={"Yes, Delete"}
            handleClose={onClose}
            handleOk={() => {
              onClose();
              const uuidListToDelete = _.map(selectedFlatRows, "values.uuid.props.text");
              _.forEach(uuidListToDelete, uuid => {
                deleteBrand(uuid, handleRefresh);
              });

              alert('Successfully Deleted !!!');
              resetSelectedRows();
            }}
          />
        );
      },
    });
  };

  const onEditClicked = (selectedFlatRows, resetSelectedRows) => {
    const uuid = _.get(selectedFlatRows, '[0].values.uuid.props.text', null);
    const shortMediaItem = brandsResponse.find(item => item.uuid === uuid);
    setBrandRow(shortMediaItem);
    setShowBrandModal(true);
    resetSelectedRows();
  };

  const handleRefresh = () => {
    setRefresh(prevRefresh => !prevRefresh);
  };

  const onUpdate = (response) => {
    setShowBrandModal(false);
    handleRefresh();
  };

  const handleCreate = () => {
    setBrandRow(null);
    setShowBrandModal(true);
  };

  return (
    <LoadingOverlay
      active={isLoadingBrands || isDeleting}
      spinner={<ScaleLoader />}
      text={isDeleting ? "Deleting the selected brand items." : "Loading Brands..."}
    >
      <BasicLayout pagePermission="moderate_precalc">
        <ToastContainer autoClose={2000} />
        <Row>
          <Col md={9}>
            <h3 className="content_editor_title">{"Brands"}</h3>
          </Col>
          <Col md={3} style={{ paddingTop: "20px" }}>
            <button
              style={{
                display: "inline-block",
                padding: "10px 20px",
                backgroundColor: "green",
                color: "white",
                textDecoration: "none",
                borderRadius: "4px",
              }}
              onClick={handleCreate}
            >
              Create
            </button>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <div className="form-group">
              <label
                style={{
                  marginRight: "5px",
                }}
              >
                {"Active : "}
              </label>
              <MPSelect
                items={convertArrayToObjMap(["true", "false"])}
                selectedItem={active}
                onChangeSelect={(e) => setActive(e)}
              />
            </div>
          </Col>
        </Row>
        <QalboxTable
          table={{
            data: getBrandDisplayData(brandsResponse),
            columns: getQalboxBrandColumns(),
            handleDelete: onDeleteSelected,
            handleEdit: onEditClicked,
            isLoading: isLoadingBrands,
            tableError: errorFetching,
          }}
        />
      </BasicLayout>
      <AppModal
        show={ShowBrandModal}
        showBody={true}
        headingText={`Create a Brand`}
        modalBody={
          <BrandModal
            data={brandRow}
            handleUpdates={onUpdate}
          />
        }
        modalBodyClassName={""}
        closeButtonText={""}
        okButtonText={""}
        handleClose={() => {setShowBrandModal(false); setBrandRow(null)}}
      />
    </LoadingOverlay>
  );
};

export default QalboxBrands;
